import React from "react";
import MuiTableContainer from "@mui/material/TableContainer";
import PropTypes from "prop-types";

/**
 * TableContainer component wrapper for table container.
 * Wraps Material-UI TableContainer with theme integration.
 * 
 * @component
 * @example
 * <TableContainer component={Paper}>
 *   <Table>
 *     ...
 *   </Table>
 * </TableContainer>
 */
const TableContainer = ({ children, ...props }) => {
  return <MuiTableContainer {...props}>{children}</MuiTableContainer>;
};

TableContainer.propTypes = {
  /**
   * The content of the component, normally Table
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI TableContainer behavior

export default TableContainer;

